export class ClienteBancos {
    public id_cia: number;
    public codban: number;
    public desban: string;
    public tipcta: number;
    public descta: string;
    public tipmon: string;
    public cuenta: string;
    //    private List<ClaseCodigoDescripcion> clases;
}